import request from '@/utils/request'

export function login(data) {
  return request({ url: '/auth/login', method: 'post', data })
}

export function logout() {
  return request({ url: '/auth/logout', method: 'post' })
}

export function getUserInfo() {
  return request({ url: '/auth/info', method: 'get' })
}

export function getRoutes() {
  return request({ url: '/auth/routes', method: 'get' })
}

export function changePassword(data) {
  return request({ url: '/auth/changePassword', method: 'post', data })
}
